<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4" style="max-width: 400px">
        <v-card
          v-if="!loadingValidate"
          shaped
          class="elevation-24"
          :style="{ 'border-bottom-right-radius': '0px' }"
        >
          <v-list-item class="pt-6">
            <v-list-item-content>
              <v-img src="@/assets/logo-bni-qris.webp" max-width="8rem"></v-img>

              <h2 class="mt-4 font-weight-black">Input Password</h2>
            </v-list-item-content>
          </v-list-item>
          <v-card-text style="padding-bottom: 4px">
            <div class="grey--text text-justify">
              Silakan masukan password baru Anda
            </div>
            <v-form ref="form" lazy-validation v-on:submit.prevent="">
              <v-text-field
                label="Password"
                name="password"
                prepend-icon="mdi-lock"
                :type="showPassword ? 'text' : 'password'"
                v-model="password"
                :error-messages="passwordErrors"
                @change="$v.password.$touch()"
                @blur="$v.password.$touch()"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
              />
              <v-text-field
                label="Password Confirmation"
                name="passwordConfirmation"
                prepend-icon="mdi-lock-check"
                :type="showPasswordConfirmation ? 'text' : 'password'"
                v-model="passwordConfirmation"
                v-on:keyup.enter="submitPassword"
                :error-messages="passwordConfirmationErrors"
                @change="$v.passwordConfirmation.$touch()"
                @blur="$v.passwordConfirmation.$touch()"
                :append-icon="showPasswordConfirmation ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPasswordConfirmation = !showPasswordConfirmation"
              />
            </v-form>
          </v-card-text>
          <v-card-actions
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 8px 16px 16px 16px;
            "
          >
            <v-btn
              color="orange"
              @click="back"
              :disabled="loading"
              style="color: white"
              >Back</v-btn
            >
            <v-btn
              color="#005f7a"
              style="color: white"
              @click="submitPassword"
              :disabled="loading"
              >Submit</v-btn
            >
          </v-card-actions>
          <v-progress-linear
            :active="loading"
            :indeterminate="loading"
            absolute
            bottom
            color="red lighten-2"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { minLength, sameAs } from 'vuelidate/lib/validators';
import { date } from '@/lib/helpers';

export default {
  name: 'SetPassword',
  mixins: [validationMixin],
  validations: {
    password: {
      required(value) {
        return value !== '';
      },
      minLength: minLength(12),
      upperCase(value) {
        const pattern = /[A-Z]/;
        return !!pattern.test(value);
      },
      lowerCase(value) {
        const pattern = /[a-z]/;
        return !!pattern.test(value);
      },
      specialChar(value) {
        const pattern = /[!-/:@[-`{-~]/;
        return !!pattern.test(value);
      },
      numeric(value) {
        const pattern = /\d/;
        return !!pattern.test(value);
      },
    },
    passwordConfirmation: {
      required(value) {
        return value !== '';
      },
      sameAsPassword: sameAs('password'),
    },
  },
  mounted() {
    if (this.$route.name === 'SetPassword') {
      if (
        this.$route.params.token !== '' &&
        this.$route.params.token != null
      ) {
        this.validateToken();
      }
    }
  },
  data() {
    return {
      loadingValidate: false,
      password: '',
      passwordConfirmation: '',
      validToken: false,
      showPassword: false,
      showPasswordConfirmation: false,
    };
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      if (!this.$v.password.required) errors.push('Password harus diisi');
      if (!this.$v.password.lowerCase) errors.push('Password harus mengandung huruf kecil');
      if (!this.$v.password.upperCase) errors.push('Password harus mengandung huruf besar');
      if (!this.$v.password.numeric) errors.push('Password harus mengandung angka');
      if (!this.$v.password.specialChar) errors.push('Password harus mengandung karakter spesial');
      if (!this.$v.password.minLength) errors.push('Password minimal 12 karakter');
      return errors;
    },
    passwordConfirmationErrors() {
      const errors = [];
      if (!this.$v.passwordConfirmation.$dirty) return errors;
      if (!this.$v.passwordConfirmation.required) errors.push('Konfirmasi password harus diisi');
      if (!this.$v.passwordConfirmation.sameAsPassword) errors.push('Konfirmasi password harus sama dengan password');
      return errors;
    },
  },

  methods: {
    async validateToken() {
      this.loadingValidate = true;
      let { token } = this.$route.params;
      token = token.replace(/-/g, '+');
      token = token.replace(/_/g, '/');
      
      try {
        const res = await this.$store.dispatch('validateSetPasswordToken', {
          token,
          date,
        });
        
        if (res && res.expired && res.code === 419) {
          this.$router.push('/login');
        } else if (res) {
          this.validToken = true;
          this.loadingValidate = false;
        }
      } catch (error) {
        console.error('Error validating token:', error);
        this.$router.push('/login');
      }
    },

    async submitPassword() {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.$store
          .dispatch('submitSetPassword', {
            password: this.password,
            confirm_password: this.passwordConfirmation,
            date,
          })
          .then(({ expired, code } = {}) => {
            if (expired && code === 419) {
              this.$router.push('/login');
            }
            if (code === 200) {
              setTimeout(() => {
                this.$router.push('/login');
              }, 1500);
            }
          })
          .finally(() => {
            this.$store.commit('setLoading', false);
          });
      }
    },

    back() {
      this.$router.push('/login');
    },
  },
};
</script>

<style scoped>
.border-top {
  border-radius: 24px 0px 0px 0px;
}
.header-logo {
  align-self: flex-start;
  position: absolute;
  left: 0;
  top: 0;
}
</style>
